import React from "react";
import Gallery from './Gallery.js';
import { Profile } from './Gallery.js';

export const Banner01DataSource = {
  wrapper: { className: "banner0" },
  textWrapper: { className: "banner0-text-wrapper" },
  title: {
    className: "banner0-title",
    children: "Aditya-L1 <br>Support Cell",
  },
  content: {
    className: "banner0-content",
    children:
      "A community service centre to help in doing scientific research using Aditya-L1",
  },
  button: { className: "banner0-button", children: "Learn More" },
  imgCaption: {
    className: "banner0-caption",
    children:
      "This is a color composite image of **solar eclipse** taken on 21 August, 2017. It is a composite of 311 images calibrated with dark and flat-fields taken at Mitchell and Whiskey mountain. In the image the continuum is depicted in gray color, Fe XI (789.2 nm) is shown in red, Fe XIV (530.3 nm) in green and Fe XIII (1074.7 nm) in blue color. It should be noted that VELC of Aditya-L1 will observe the inner solar corona in all these wavelengths using imaging and spectroscopy. *(Image Credits: Miloslav Druckmüller, Peter Aniol, Shadia Habbal, Pavel Štarha, Judd Johnson, Jana Hoderová)*",
  },
};
export const Content00DataSource = {
  wrapper: { className: "home-page-wrapper content0-wrapper" },
  page: { className: "home-page content0" },
  OverPack: { playScale: 0.3, className: "" },
  titleWrapper: {
    className: "title-wrapper",
    children: [{ name: "title", children: "Products and Services" }],
  },
  childWrapper: {
    className: "content0-block-wrapper",
    children: [
      {
        name: "block0",
        className: "content0-block",
        md: 8,
        xs: 24,
        children: {
          className: "content0-block-item",
          children: [
            {
              name: "image",
              className: "content0-block-icon",
              children:
                "https://zos.alipayobjects.com/rmsportal/WBnVOjtIlGWbzyQivuyq.png",
            },
            {
              name: "title",
              className: "content0-block-title",
              children: "One-stop business access",
            },
            {
              name: "content",
              children:
                "The efficiency of payment, settlement, and accounting access products has quadrupled",
            },
          ],
        },
      },
      {
        name: "block1",
        className: "content0-block",
        md: 8,
        xs: 24,
        children: {
          className: "content0-block-item",
          children: [
            {
              name: "image",
              className: "content0-block-icon",
              children:
                "https://zos.alipayobjects.com/rmsportal/YPMsLQuCEXtuEkmXTTdk.png",
            },
            {
              name: "title",
              className: "content0-block-title",
              children: "One-stop in-event risk monitoring",
            },
            {
              name: "content",
              children:
                "Prior risk control and quality control capabilities in all requirements configuration links",
            },
          ],
        },
      },
      {
        name: "block2",
        className: "content0-block",
        md: 8,
        xs: 24,
        children: {
          className: "content0-block-item",
          children: [
            {
              name: "image",
              className: "content0-block-icon",
              children:
                "https://zos.alipayobjects.com/rmsportal/EkXWVvAaFJKCzhMmQYiX.png",
            },
            {
              name: "title",
              className: "content0-block-title",
              children: "One-stop data operation",
            },
            {
              name: "content",
              children:
                "Accumulate data on product access efficiency and operational efficiency of the second grade",
            },
          ],
        },
      },
    ],
  },
};
export const Content50DataSource = {
  wrapper: { className: "home-page-wrapper content5-wrapper" },
  page: { className: "home-page content5" },
  OverPack: { playScale: 0.3, className: "" },
  titleWrapper: {
    className: "title-wrapper",
    children: [
      { name: "title", children: "Resources", className: "title-h1" },
      {
        name: "content",
        className: "title-content",
        children: "Here are a few quick links to the resources we provide.",
      },
    ],
  },
  block: {
    className: "content5-img-wrapper",
    gutter: 16,
    children: [
      {
        name: "block0",
        className: "block",
        md: 8,
        xs: 24,
        children: {
          wrapper: { className: "content5-block-content" },
          img: {
            children:
              "https://t.alipayobjects.com/images/rmsweb/T11aVgXc4eXXXXXXXX.svg",
          },
          content: { children: "Proposal Planner" },
        },
      },
      {
        name: "block1",
        className: "block",
        md: 8,
        xs: 24,
        children: {
          wrapper: { className: "content5-block-content" },
          img: {
            children:
              "https://zos.alipayobjects.com/rmsportal/faKjZtrmIbwJvVR.svg",
          },
          content: { children: "Quick look browser" },
        },
      },
      {
        name: "block2",
        className: "block",
        md: 8,
        xs: 24,
        children: {
          wrapper: { className: "content5-block-content" },
          img: {
            children:
              "https://t.alipayobjects.com/images/rmsweb/T11aVgXc4eXXXXXXXX.svg",
          },
          content: { children: "Resource-3" },
        },
      },
      {
        name: "block3",
        className: "block",
        md: 8,
        xs: 24,
        children: {
          wrapper: { className: "content5-block-content" },
          img: {
            children:
              "https://zos.alipayobjects.com/rmsportal/faKjZtrmIbwJvVR.svg",
          },
          content: { children: "Resource-4" },
        },
      },
      {
        name: "block4",
        className: "block",
        md: 8,
        xs: 24,
        children: {
          wrapper: { className: "content5-block-content" },
          img: {
            children:
              "https://t.alipayobjects.com/images/rmsweb/T11aVgXc4eXXXXXXXX.svg",
          },
          content: { children: "Resource-5" },
        },
      },
      {
        name: "block5",
        className: "block",
        md: 8,
        xs: 24,
        children: {
          wrapper: { className: "content5-block-content" },
          img: {
            children:
              "https://zos.alipayobjects.com/rmsportal/faKjZtrmIbwJvVR.svg",
          },
          content: { children: "Resource-6" },
        },
      },
    ],
  },
};
export const Content30DataSource = {
  wrapper: { className: "home-page-wrapper content3-wrapper" },
  page: { className: "home-page content3" },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: "title-wrapper",
    children: [
      {
        name: "title",
        children: "Objectives",
        className: "title-h1",
      },
      {
        name: "content",
        className: "title-content",
        children: "Aditya-L1 Science Support Cell has the following goals",
      },
    ],
  },
  block: {
    className: "content3-block-wrapper",
    children: [
      {
        name: "block0",
        className: "content3-block",
        md: 12,
        xs: 24,
        children: {
          icon: {
            className: "content3-icon",
            children:
              "https://zos.alipayobjects.com/rmsportal/ScHBSdwpTkAHZkJ.png",
          },
          textWrapper: { className: "content3-text" },
          title: {
            className: "content3-title",
            children: "Enterprise Resource Management",
          },
          content: {
            className: "content3-content",
            children:
              "Jointly work with ISRO to maximize utilization of science data from Aditya-L1.",
          },
        },
      },
      {
        name: "block1",
        className: "content3-block",
        md: 12,
        xs: 24,
        children: {
          icon: {
            className: "content3-icon",
            children:
              "https://zos.alipayobjects.com/rmsportal/NKBELAOuuKbofDD.png",
          },
          textWrapper: { className: "content3-text" },
          title: { className: "content3-title", children: "Cloud security" },
          content: {
            className: "content3-content",
            children:
              "Develop specific tools to assist guest observers to prepare proposals for Aditya-L1 observations.",
          },
        },
      },
      {
        name: "block2",
        className: "content3-block",
        md: 12,
        xs: 24,
        children: {
          icon: {
            className: "content3-icon",
            children:
              "https://zos.alipayobjects.com/rmsportal/xMSBjgxBhKfyMWX.png",
          },
          textWrapper: { className: "content3-text" },
          title: { className: "content3-title", children: "Cloud monitoring" },
          content: {
            className: "content3-content",
            children:
              "Design and develop required analysis software (for handling data beyond Level-2) in consultation with ISRO.",
          },
        },
      },
      {
        name: "block3",
        className: "content3-block",
        md: 12,
        xs: 24,
        children: {
          icon: {
            className: "content3-icon",
            children:
              "https://zos.alipayobjects.com/rmsportal/MNdlBNhmDBLuzqp.png",
          },
          textWrapper: { className: "content3-text" },
          title: { className: "content3-title", children: "Mobile" },
          content: {
            className: "content3-content",
            children:
              "Establish periodic training of the national user community om data analysis and proposal preparation.",
          },
        },
      },
      // {
      //   name: "block4",
      //   className: "content3-block",
      //   md: 8,
      //   xs: 24,
      //   children: {
      //     icon: {
      //       className: "content3-icon",
      //       children:
      //         "https://zos.alipayobjects.com/rmsportal/UsUmoBRyLvkIQeO.png",
      //     },
      //     textWrapper: { className: "content3-text" },
      //     title: {
      //       className: "content3-title",
      //       children: "Distributed middleware",
      //     },
      //     content: {
      //       className: "content3-content",
      //       children:
      //         "Financial-level online transaction processing middleware, large-scale distributed computers, and tens of thousands of transactions/second level concurrency, strictly guarantee the unity of transaction data.",
      //     },
      //   },
      // },
      // {
      //   name: "block5",
      //   className: "content3-block",
      //   md: 8,
      //   xs: 24,
      //   children: {
      //     icon: {
      //       className: "content3-icon",
      //       children:
      //         "https://zos.alipayobjects.com/rmsportal/ipwaQLBLflRfUrg.png",
      //     },
      //     textWrapper: { className: "content3-text" },
      //     title: { className: "content3-title", children: "Big Data" },
      //     content: {
      //       className: "content3-content",
      //       children:
      //         "One-stop, full-cycle big data collaborative work platform, PB-level data processing, millisecond-level data analysis tools.",
      //     },
      //   },
      // },
    ],
  },
};
export const Feature20DataSource = {
  wrapper: { className: "home-page-wrapper content2-wrapper" },
  OverPack: { className: "home-page content2", playScale: 0.3 },
  imgWrapper: { className: "content2-img", md: 12, xs: 24 },
  img: {
    className: "content2-img-inner",
    children: [
      {
        path: "Fig1.png",
        caption:
          "A white-light image of the corona (background grey-scaled image) taken during a total eclipse by Miloslav Druckmüller highlights the  FOV  of the VELC white-light image. The central disk image is obtained by the IRIS instrument from a special  mosaic of the Mg II k line (the same line will be observed by SUIT). The location of the four slits of VELC is marked in red.  The inner black square shows the spectroscopic FOV of the VELC.",
      },
      {
        path: "Fig2.png",
        caption:
          "A comparison of field of views of Aditya-L1 coronagraph with upcoming missions.",
      },
      {
        path: "Fig3.jpg",
        caption:
          "A comparison of in-situ magnetic field and solar wind speed measurement with a prediction model (shown in red) developed by [Pal et al. (2017)](#). The in-situ measured parameters will be provided by Aditya-L1 instruments in the future.",
      },
    ],
  },
  textWrapper: { className: "content2-text", md: 12, xs: 24 },
  title: { className: "content2-title", children: "About" },
  content: {
    className: "content2-content",
    children: [
      "Aditya-L1 mission is India's first dedicated spacecraft mission to study the Sun. The Aditya-L1 will be inserted in a halo orbit around the L1 (Lagrange 1) point, which is about 1.5 million km from Earth. It will enable a comprehensive understanding of the dynamical processes of the Sun and address some of the outstanding problems in solar physics and heliophysics. You can read more interesting details about the mission [here](#).",
      "As a joint effort of ISRO and ARIES, the Aditya-L1 Science Support Cell has been set up to act as a community service centre for the guest observers in preparing science observing proposals and analyzing science data. This support cell provides tools and documentation required to understand, download and analyse the data. It will be regularly updated and will also provide an online help desk with professional researchers and PhD students on-board.",
    ],
  },
};
export const Feature70DataSource = {
  wrapper: { className: "home-page-wrapper feature7-wrapper" },
  page: { className: "home-page feature7" },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: "feature7-title-wrapper",
    children: [
      {
        name: "title",
        className: "feature7-title-h1",
        children: "News & Updates",
      },
      {
        name: "content",
        className: "feature7-title-content",
        children: "",
      },
    ],
  },
  blockWrapper: {
    className: "feature7-block-wrapper",
    gutter: 24,
    children: [
      {
        md: 8,
        xs: 24,
        name: "block0",
        className: "feature7-block",
        children: {
          className: "feature7-block-group",
          children: [
            {
              name: "image",
              className: "feature7-block-image",
              children:
                "https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg",
            },
            {
              name: "title",
              className: "feature7-block-title",
              children: "2021-05-12",
            },
            {
              name: "content",
              className: "feature7-block-content",
              children:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            },
          ],
        },
      },
      {
        md: 8,
        xs: 24,
        name: "block1",
        className: "feature7-block",
        children: {
          className: "feature7-block-group",
          children: [
            {
              name: "image",
              className: "feature7-block-image",
              children:
                "https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg",
            },
            {
              name: "title",
              className: "feature7-block-title",
              children: "2021-04-30",
            },
            {
              name: "content",
              className: "feature7-block-content",
              children:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            },
          ],
        },
      },
      {
        md: 8,
        xs: 24,
        name: "block2",
        className: "feature7-block",
        children: {
          className: "feature7-block-group",
          children: [
            {
              name: "image",
              className: "feature7-block-image",
              children:
                "https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg",
            },
            {
              name: "title",
              className: "feature7-block-title",
              children: "2021-04-15",
            },
            {
              name: "content",
              className: "feature7-block-content",
              children:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            },
          ],
        },
      },
      // {
      //   md: 6,
      //   xs: 24,
      //   name: "block3",
      //   className: "feature7-block",
      //   children: {
      //     className: "feature7-block-group",
      //     children: [
      //       {
      //         name: "image",
      //         className: "feature7-block-image",
      //         children:
      //           "https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg",
      //       },
      //       {
      //         name: "title",
      //         className: "feature7-block-title",
      //         children: "身份证",
      //       },
      //       {
      //         name: "content",
      //         className: "feature7-block-content",
      //         children:
      //           "Establish periodic training of the national user community om data analysis and proposal preparation",
      //       },
      //     ],
      //   },
      // },
      // {
      //   md: 6,
      //   xs: 24,
      //   name: "block4",
      //   className: "feature7-block",
      //   children: {
      //     className: "feature7-block-group",
      //     children: [
      //       {
      //         name: "image",
      //         className: "feature7-block-image",
      //         children:
      //           "https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg",
      //       },
      //       {
      //         name: "title",
      //         className: "feature7-block-title",
      //         children: "身份证",
      //       },
      //       {
      //         name: "content",
      //         className: "feature7-block-content",
      //         children: "识别身份证正反面姓名、身份证号、发证机关等相关信息",
      //       },
      //     ],
      //   },
      // },
      // {
      //   md: 6,
      //   xs: 24,
      //   name: "block5",
      //   className: "feature7-block",
      //   children: {
      //     className: "feature7-block-group",
      //     children: [
      //       {
      //         name: "image",
      //         className: "feature7-block-image",
      //         children:
      //           "https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg",
      //       },
      //       {
      //         name: "title",
      //         className: "feature7-block-title",
      //         children: "身份证",
      //       },
      //       {
      //         name: "content",
      //         className: "feature7-block-content",
      //         children: "识别身份证正反面姓名、身份证号、发证机关等相关信息",
      //       },
      //     ],
      //   },
      // },
      // {
      //   md: 6,
      //   xs: 24,
      //   name: "block6",
      //   className: "feature7-block",
      //   children: {
      //     className: "feature7-block-group",
      //     children: [
      //       {
      //         name: "image",
      //         className: "feature7-block-image",
      //         children:
      //           "https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg",
      //       },
      //       {
      //         name: "title",
      //         className: "feature7-block-title",
      //         children: "身份证",
      //       },
      //       {
      //         name: "content",
      //         className: "feature7-block-content",
      //         children: "识别身份证正反面姓名、身份证号、发证机关等相关信息",
      //       },
      //     ],
      //   },
      // },
      // {
      //   md: 6,
      //   xs: 24,
      //   name: "block7",
      //   className: "feature7-block",
      //   children: {
      //     className: "feature7-block-group",
      //     children: [
      //       {
      //         name: "image",
      //         className: "feature7-block-image",
      //         children:
      //           "https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg",
      //       },
      //       {
      //         name: "title",
      //         className: "feature7-block-title",
      //         children: "身份证",
      //       },
      //       {
      //         name: "content",
      //         className: "feature7-block-content",
      //         children: "识别身份证正反面姓名、身份证号、发证机关等相关信息",
      //       },
      //     ],
      //   },
      // },
    ],
  },
};



export default function App() {
  return (
    <Profile />
  );
}


export const Footer10DataSource = {
  wrapper: { className: "home-page-wrapper footer1-wrapper" },
  OverPack: { className: "footer1", playScale: 0.2 },
  block: {
    className: "home-page",
    gutter: 0,
    children: [
      {
        name: "block0",
        xs: 24,
        lg: 5,
        className: "block block0",
        title: {
          className: "logo",
          children: "AL1SSC_title.svg",
        },
        childWrapper: {
          // className: "slogan",
          children: [
            {
              name: "content0",
              children: "A joint effort of ISRO & ARIES",
            },
            {
              name: "isro-link",
              children: "images/isro_logo.jpg",
              href: "https://www.isro.gov.in/",
            },
            {
              name: "aries-link",
              children: "images/aries_logo.jpg",
              href: "https://www.aries.res.in/",
            },
          ],
        },
      },
      {
        name: "block1",
        xs: 24,
        lg: 10,
        className: "block block1",
        title: { children: "Collaborating Institutes" },
        childWrapper: {
          children: [
            {
              name: "link0",
              href: "https://www.iiap.res.in/",
              children: "images/iia_logo.jpg",
            },
            {
              name: "link1",
              href: "https://www.iucaa.in/",
              children: "images/iucaa_logo.png",
            },
            {
              name: "link2",
              href: "https://www.prl.res.in/",
              children: "images/prl_logo.jpg",
            },
            {
              name: "link3",
              href: "https://www.iiserkol.ac.in/",
              children: "images/iiser_kolkata_logo.jpg",
            },
            {
              name: "link4",
              href: "https://www.iiserpune.ac.in/",
              children: "images/iiser_pune_logo.jpg",
            },
            {
              name: "link5",
              href: "https://www.iitbhu.ac.in/",
              children: "images/iit_bhu_logo.jpg",
            },
            {
              name: "link6",
              href: "https://www.tifr.res.in/",
              children: "images/tifr_logo.jpg",
            },
          ],
        },
      },
      {
        name: "block2",
        xs: 24,
        lg: 4,
        className: "block block2",
        title: { children: "Help" },
        childWrapper: {
          children: [
            { href: "faqs", name: "link0", children: "FAQ" },
            {
              href: "contact",
              name: "link1",
              children: "Contact us",
            },
          ],
        },
      },
      {
        name: "block3",
        xs: 24,
        lg: 4,
        className: "block1 block3",
        title: { children: "Follow us on" },
        childWrapper: {
          children: [
            {
              name: "facebook_link",
              href: "https://www.facebook.com/AdityaL1SC",
              children: "images/facebook_icon.png",
            },
            {
              name: "twitter_link",
              href: "https://twitter.com/AdityaL1SC",
              children: "images/twitter_icon.png",
            },
            {
              name: "youtube_link",
              href: "https://www.youtube.com/@adityal1sc",
              children: "images/youtube_icon.png",
            },
          ],
        },
      },
      // {
      //   name: "block3",
      //   xs: 24,
      //   md: 8,
      //   className: "block",
      //   title: { children: "Resources" },
      //   childWrapper: {
      //     children: [
      //       { href: "#", name: "link0", children: "Ant Design" },
      //       { href: "#", name: "link1", children: "Ant Motion" },
      //     ],
      //   },
      // },
    ],
  },
  copyrightWrapper: { className: "copyright-wrapper" },
  copyrightPage: { className: "home-page" },
  copyright: {
    className: "copyright",
    children: (
      <span>
        ©2021{" "}
        <a href="https://aries.res.in">
          ARIES (Aryabhatta Research Institute of observational sciencES)
        </a>
      </span>
    ),
  },
};        
